import './src/styles/global.css';
import wrapWithProviders from './src/hooks/rootWrapper';

export const wrapRootElement = wrapWithProviders;
